import { Button } from "antd"
import { ReactNode } from "react"
import {Loading3QuartersOutlined} from "@ant-design/icons"
import "./index.less"

interface IProps {
    showRetry: boolean
    children: ReactNode
    onRetryClick: () => void
}

export const Retry = ({ onRetryClick, children, showRetry }: IProps) => {

    if(showRetry) {
        return <div className="retry">
            <Button onClick={onRetryClick} size="large">Retry<Loading3QuartersOutlined /></Button>
            <p>Click for start loading process in case it was failed before</p>
        </div>
    }

    return <>{children}</>
}
